import { Loader } from 'src/design/atoms/Loader';
import { Text } from 'src/design/atoms/Text';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useAdminUserDetail } from 'src/api/queries/organization/useAdminUserDetail';
import { Header } from 'src/design/organisms/Header';
import { UserForm } from 'src/routes/Settings/Users/components/UserForm';

export const UpdateUser: React.FC = () => {
  const params = useParams<{ id: string }>();
  const { data: user, isLoading: loading } = useAdminUserDetail(
    Number(params.id),
  );

  const userTitle = loading
    ? 'Loading...'
    : user
    ? user.fullName
    : params.id ?? 'User';

  return (
    <>
      <Header
        breadcrumbProps={{
          items: [
            { text: 'Settings', href: '/settings' },
            { text: 'Users', href: '/settings/users' },
            { text: userTitle },
          ],
        }}
        title={userTitle}
        helpText="Users can login to the system and access the divisions and jobs they are assigned to."
      />
      {loading ? (
        <div className="text-center">
          <Loader />
        </div>
      ) : user ? (
        <UserForm initialValues={user} />
      ) : (
        <Text c="dimmed">User not found.</Text>
      )}
    </>
  );
};
